import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface SaveAnalysisParams {
  jobTitle: string;
  location: string;
  yearsExperience: number;
  skills: string[];
  currentSalary?: number;
  industry?: string;
  companySize?: string;
  educationLevel?: string;
  marketData: any;
  aiAnalysis?: any;
}

export function useSaveSalaryAnalysis() {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: SaveAnalysisParams) => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("salary_analyses")
        .insert({
          user_id: user.id,
          job_title: params.jobTitle,
          location: params.location,
          years_experience: params.yearsExperience,
          skills: params.skills,
          current_salary: params.currentSalary,
          industry: params.industry,
          company_size: params.companySize,
          education_level: params.educationLevel,
          market_data: params.marketData,
          ai_analysis: params.aiAnalysis,
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["salary-analyses"] });
      toast({
        title: "Analysis Saved",
        description: "Your salary analysis has been saved to history",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Save Failed",
        description: error.message,
        variant: "destructive",
      });
    },
  });
}
